import { render } from "./EquipmentForm.vue?vue&type=template&id=da34e502"
import script from "./EquipmentForm.vue?vue&type=script&lang=ts"
export * from "./EquipmentForm.vue?vue&type=script&lang=ts"
script.render = render

export default script